import React from 'react'
import { CircularProgress, Grid } from '@mui/material'

const Spinner = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ width: '100%', height: '100vh' }}
    >
      <Grid item>
        <CircularProgress size={100} />
      </Grid>
    </Grid>
  );
}

export default Spinner
